<div class="surface-0">
  <app-menubar></app-menubar>
  <p-toast></p-toast>

  <div class="grid mb-2">
    <div class="col-2" *ngIf="navbarVisible">
      <app-navbar></app-navbar>
    </div>
    <div class="col-10" [class.col-12]="!navbarVisible">

      <p-dropdown [options]="listCompanies" (onChange)="onCompanyChange($event)" optionLabel="name"
        placeholder="Selecione uma empresa" />

      <p-button icon="pi pi-plus" label="" class="ml-2" (click)="addItemCategoryCompany()"></p-button>

       <!--companies category-->
      <p-table #dt1 [value]="companiesCategory" [(selection)]="selectedComanycategory" dataKey="id" [rows]="50"
        [showCurrentPageReport]="true" [rowsPerPageOptions]="[10, 20, 40]" [paginator]="true"
        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="[]"
        scrollDirection="horizontal" [scrollable]="true" [filterDelay]="0" scrollHeight="600px" editMode="row">
        <ng-template pTemplate="caption">
        </ng-template>
        <ng-template pTemplate="header">
          <tr>
            <th>Empresa</th>
            <th>Del</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-code let-item="rowIndex">
          <tr>
            <td>{{ code.name}}</td>
            <td>
              <p-button icon="pi pi-times" styleClass="p-button-rounded p-button-danger p-button-text"
                (click)="deleteCategoryCompany(item)">
              </p-button>
            </td>

        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="7">Não foi encontrada nenhuma categoria.</td>
          </tr>
        </ng-template>
      </p-table>

      <input id="nomeCategoria" name="nomeCategoria" pInputText placeholder="Digite o nome da categoria"
        class="w-full mt-2" [(ngModel)]="nomeCategoria" />
      <p-fileUpload chooseLabel="Foto" [showUploadButton]=true uploadLabel="Publicar" cancelLabel="Cancelar"
        [customUpload]="true" accept="image/*" (uploadHandler)="criarCategoria($event)">
      </p-fileUpload>


    </div>
  </div>
</div>